import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';

import pgmTheme from './theme';
import Copyright from 'components/CopyRight';

const PlainLayout = ({ children }) => {
  return (
    <ThemeProvider theme={pgmTheme}>
      {/* <Container maxWidth="xl"> */}
        <Box sx={{ display: 'flex', }}>
          {children}
        </Box>
        <Copyright sx={{ p: 2, backgroundColor: '#ffffff'}} />  

      {/* </Container> */}
    </ThemeProvider>
  );
}
 
export default PlainLayout;
